import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
const ChevronLeft = (props) => (<Svg viewBox="0 0 20 20" {...props} fill="transparent" style={{ transform: [{ rotate: '180deg' }] }}>
    <Path d="m7.5 5 5 5-5 5" stroke={props.stroke ?? '#8F95B2'} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>);
export default ChevronLeft;
